// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart[data-v-1f2b5b2e] {\n  height: 34vh;\n}\n*[data-v-1f2b5b2e] {\n  background: #fff;\n  margin-bottom: 10px;\n  border-radius: 10px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n", ""]);
// Exports
module.exports = exports;
